/**
 * Semver-Vergleich für die Admin-Warnung (gleiche Regeln wie lib/appVersion.js).
 */

export function parseVersionParts(value) {
    const raw = String(value == null ? '' : value).trim();
    if (!raw) {
        return null;
    }
    const core = raw.split(/[-+]/)[0];
    const nums = core.split('.').map((part) => Number.parseInt(part, 10));
    if (!nums.length || nums.some((n) => Number.isNaN(n) || n < 0)) {
        return null;
    }
    while (nums.length < 3) {
        nums.push(0);
    }
    return nums.slice(0, 3);
}

export function compareVersions(a, b) {
    const pa = parseVersionParts(a);
    const pb = parseVersionParts(b);
    if (!pa || !pb) {
        return 0;
    }
    for (let i = 0; i < 3; i += 1) {
        if (pa[i] > pb[i]) {
            return 1;
        }
        if (pa[i] < pb[i]) {
            return -1;
        }
    }
    return 0;
}

export function isVersionSupported(version, minVersion) {
    const min = String(minVersion == null ? '' : minVersion).trim();
    if (!min) {
        return true;
    }
    if (!parseVersionParts(min) || !parseVersionParts(version)) {
        return true;
    }
    return compareVersions(version, min) >= 0;
}

/** Eindeutige Nutzer in `versions`, deren Version unter minVersion liegt. */
export function countWouldBlock(versions, minVersion) {
    const list = Array.isArray(versions) ? versions : [];
    if (!String(minVersion || '').trim()) {
        return 0;
    }
    return list.reduce((sum, row) => {
        if (isVersionSupported(row.name, minVersion)) {
            return sum;
        }
        return sum + (Number(row.count) || 0);
    }, 0);
}
